import { chatModeType } from '../../../../../types/Chat/Chat.types';
import FileItem from '../../../../common/FileItem/FileItem';
import { type UploadedFile } from '../../Input/Input';

interface UserMessageProps {
    readonly text: string;
    readonly files: UploadedFile[];
    readonly chatMode: chatModeType;
    readonly interactionId?: string; // Optional - only available after backend processes the message
}

export const UserMessage = ({ text, files }: UserMessageProps) => {
    return (
        <div className="flex justify-end w-full group">
            <div className="bg-gray-qm-100/70 dark:bg-gray-qm-900 p-3 rounded-2xl max-w-[80%] md:max-w-[70%] relative">
                {text && (
                    <div className={`${files.length > 0 && 'mb-2'}`} data-testid="user-message">
                        {text}
                    </div>
                )}
                {files.length > 0 && (
                    <div className="flex flex-col space-y-2">
                        {files.map((file, index) => (
                            <FileItem key={index} file={file} isLoading={false} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserMessage;
